import { MealPlanType } from "libs/api/customer/src/lib/types/cats";

import { PricingPlan } from "@/primary-models";

export const pricingPlanToRechargeSubscriptionProperty: Record<PricingPlan, MealPlanType> = {
  [PricingPlan.STANDARD]: "Plan28x28",
  [PricingPlan.SAVER]: "Plan42x42",
  [PricingPlan.HALF]: "Plan28x56",
  [PricingPlan.FREEZER]: "Plan14x14",
  [PricingPlan.TRIAL]: "PlanTrial14x14",
};

export const rechargeSubscriptionPropertyToPricingPlan: Partial<Record<MealPlanType, PricingPlan>> = {
  Plan28x28: PricingPlan.STANDARD,
  Plan42x42: PricingPlan.SAVER,
  Plan28x56: PricingPlan.HALF,
  Plan14x14: PricingPlan.FREEZER,
  PlanTrial14x14: PricingPlan.TRIAL,
} as const;

export type RechargePricingPlanName = keyof typeof rechargeSubscriptionPropertyToPricingPlan;
